import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Charsets_getInstancezrqwjk0yrlyw as Charsets_getInstance } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { charset3qqtyytkmxogi as charset } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { Source1shr0ps16u4p4 as Source } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Source.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { decode1t43jmuxrxpmo as decode } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpResponseClass;
function HttpResponse() {
  if (HttpResponseClass === VOID) {
    class $ {
      toString() {
        return 'HttpResponse[' + get_request(this).get_url_18iuii_k$().toString() + ', ' + this.get_status_jnf6d7_k$().toString() + ']';
      }
    }
    initMetadataForClass($, 'HttpResponse');
    HttpResponseClass = $;
  }
  return HttpResponseClass;
}
function get_request(_this__u8e3s4) {
  return _this__u8e3s4.get_call_wojxrb_k$().get_request_jdwg4m_k$();
}
function *bodyAsText(_this__u8e3s4, fallbackCharset, $completion) {
  fallbackCharset = fallbackCharset === VOID ? Charsets_getInstance().UTF_8__1 : fallbackCharset;
  var tmp0_elvis_lhs = charset(_this__u8e3s4);
  var originCharset = tmp0_elvis_lhs == null ? fallbackCharset : tmp0_elvis_lhs;
  var decoder = originCharset.newDecoder_zcettw_k$();
  // Inline function 'io.ktor.client.call.body' call
  var tmp = _this__u8e3s4.get_call_wojxrb_k$();
  // Inline function 'io.ktor.util.reflect.typeInfo' call
  var tmp_0 = getKClass(Source());
  // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
  var tmp_1;
  try {
    tmp_1 = createKType(getKClass(Source()), arrayOf([]), false);
  } catch ($p) {
    var tmp_2;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_2 = null;
    } else {
      throw $p;
    }
    tmp_1 = tmp_2;
  }
  var tmp$ret$2 = tmp_1;
  var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
  var tmp_3 = yield* tmp.bodyNullable_wn8z59_k$(tmp$ret$1, $completion);
  var input = (!(tmp_3 == null) ? isInterface(tmp_3, Source()) : false) ? tmp_3 : THROW_CCE();
  return decode(decoder, input);
}
//region block: exports
export {
  bodyAsText as bodyAsText193cd91fn5h1t,
  HttpResponse as HttpResponse1532ob1hsse1y,
  get_request as get_request3dwcif5y0fvf1,
};
//endregion

//# sourceMappingURL=HttpResponse.mjs.map
